import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { createdVsResolvedReportEntrypoint } from '@jira/spa-apps__reports-created-vs-resolved/src/createdVsResolvedReport.entrypoint.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getProjectViewResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { businessProjectLayout } from '@jira/platform__layouts-business-project-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@jira/platform__project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraBusinessCreatedVsResolvedRoute } from '@jira/router-routes__business-reports-routes/src/jiraBusinessCreatedVsResolvedRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { jiraHorizontalNavEntrypoint } from '@jira/navigation-apps__horizontal-nav-jira/src/jiraHorizontalNavEntrypoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const createdVsResolvedPageEntrypoint = createPageEntryPoint({
	main: createdVsResolvedReportEntrypoint,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const jiraBusinessCreatedVsResolvedRouteEntry: Route = createEntry(
	jiraBusinessCreatedVsResolvedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.reports-created-vs-resolved',

		layout: businessProjectLayout,
		skeleton: ThemedLazySkeleton,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		resources: getProjectViewResources(),

		entryPoint: () => createdVsResolvedPageEntrypoint,

		supportsProjectTheme: 'full',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
